export enum Navigation {
  Campaigns = '/',
  Events = '/events',
  Transactions = '/transactions',
  Troubleshooting = '/troubleshooting',
}

export const DISABLED_COOKIES = 'Disabled cookies';

export const SENTRY_TAG_ERROR_BOUNDARY = 'ErrorBoundary' as const;
